<template>
  <div class="manage-button">
    <PrimaryBtn v-if="outerLink" class="btn" @click="openLink">{{ $t('bounty.applyBounty') }}</PrimaryBtn>
    <LoginButton v-else-if="$store.state.id.length===0" :label="$t('bounty.applyBounty')" @login="$emit('login')" show-tip />
    <PrimaryBtn v-else-if="applyStatus===BOUNTY_STATUS.unsubmitted" class="btn" @click="submitApply">{{ $t('bounty.applyBounty') }}</PrimaryBtn>
    <PrimaryBtn v-else-if="applyStatus===BOUNTY_STATUS.submitted" class="btn" disabled>{{ $t('bounty.moderated') }}</PrimaryBtn>
    <PrimaryBtn
      v-else-if="applyStatus===BOUNTY_STATUS.pass&&[BOUNTY_STATUS.unsubmitted, BOUNTY_STATUS.submitted].includes(submitStatus)"
      class="btn"
      @click="emitSubmit"
    >
      {{ $t('bounty.submitBounty') }}
    </PrimaryBtn>
  </div>
</template>

<script>
import PrimaryBtn from '@/components/PrimaryBtn.vue';
import { BOUNTY_STATUS } from '@/config/enum';
import LoginButton from '@/components/LoginButton.vue';
import URLS from '@/config/url';

export default { // todo fix status
  name: 'ManageButtons',
  components: { LoginButton, PrimaryBtn },
  props: {
    applyStatus: {
      type: Number,
      require: true,
    },
    submitStatus: {
      type: Number,
      require: true,
    },
    outerLink: {
      type: String,
      require: false,
      default: '',
    },
  },
  data() {
    return {
      BOUNTY_STATUS,
    };
  },
  methods: {
    emitSubmit() {
      this.$emit('submit');
    },
    submitApply() {
      this.$request({
        url: URLS.applyBounty,
        method: 'post',
        data: {
          ontid: this.$store.state.id,
          bounty_id: Number(this.$route.query.id),
        },
      }).then(() => {
        this.$toast(this.$t('common.applySuccess'));
        this.$emit('apply');
      });
    },
    openLink() {
      window.open(this.outerLink);
    },
  },
};
</script>

<style lang="scss" scoped>
  .manage-button {
    font-size: 20px;
  }

  .btn {
    box-sizing: border-box;
    width: 240px;
    height: 44px;
  }
</style>
